/* Beaver-Premiumseite, Familie rescu-bvp (15.10.2026).
   Alles additiv: Ohne dieses Skript ist jede Section vollständig lesbar, der
   Rechner zeigt die in Liquid gerechneten Startwerte, die Bühne den fertigen
   Damm. Mehrfach eingebunden (eine Zeile je Section), läuft aber nur einmal. */
(function () {
  if (window.__bvpGeladen) return;
  window.__bvpGeladen = true;

  var html = document.documentElement;
  var bewegung = !(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  html.classList.add('bvp-js');
  if (bewegung) html.classList.add('bvp-bewegung');

  var fmt = new Intl.NumberFormat('de-DE');
  var fmt1 = new Intl.NumberFormat('de-DE', { minimumFractionDigits: 1, maximumFractionDigits: 1 });

  /* Zuletzt gewählte Werte, die jeder Angebots-Button ins Formular trägt */
  var auswahl = { rechner: null, bereich: null };

  function bereit(fn) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn);
    else fn();
  }

  /* ---------- Einblendungen ---------- */
  function einblenden() {
    var ziele = document.querySelectorAll('.bvp [data-bvp-rv], .bvp [data-bvp-staffel], .bvp [data-bvp-mannschaft]');
    ziele.forEach(function (el) {
      if (el.hasAttribute('data-bvp-staffel')) {
        Array.prototype.forEach.call(el.children, function (k, i) { k.style.setProperty('--n', Math.min(i, 8)); });
      }
    });
    if (!bewegung || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (eintraege) {
      eintraege.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px 6% 0px', threshold: 0.01 });
    ziele.forEach(function (el) { io.observe(el); });
  }

  /* ---------- Kennzahlen zählen hoch (Endwert steht im Markup) ---------- */
  function zaehler() {
    if (!bewegung || !('IntersectionObserver' in window)) return;
    var gruppen = document.querySelectorAll('[data-bvp-zaehler-gruppe]');
    var io = new IntersectionObserver(function (eintraege) {
      eintraege.forEach(function (e) {
        if (!e.isIntersecting) return;
        io.unobserve(e.target);
        e.target.querySelectorAll('[data-bvp-zahl]').forEach(function (z) {
          var text = z.textContent.trim();
          var m = text.match(/^(\d{1,3}(?:\.\d{3})*|\d+)(\+?)$/);
          if (!m) return;
          var ziel = parseInt(m[1].replace(/\./g, ''), 10);
          if (!(ziel >= 10) || (ziel >= 1900 && ziel <= 2100 && m[1].indexOf('.') < 0)) return;
          var start = null, dauer = 1400;
          function schritt(t) {
            if (!start) start = t;
            var p = Math.min(1, (t - start) / dauer);
            var w = Math.round(ziel * (1 - Math.pow(1 - p, 3)));
            z.textContent = fmt.format(w) + m[2];
            if (p < 1) requestAnimationFrame(schritt); else z.textContent = text;
          }
          requestAnimationFrame(schritt);
        });
      });
    }, { threshold: 0.4 });
    gruppen.forEach(function (g) { io.observe(g); });
  }

  /* ---------- Galerie im Seitenkopf ---------- */
  function galerie() {
    document.querySelectorAll('[data-bvp-galerie]').forEach(function (g) {
      var haupt = g.querySelector('.bvp-kopf__hauptbild');
      var text = g.querySelector('[data-bvp-galerie-text] span');
      var thumbs = g.querySelectorAll('[data-bvp-thumb]');
      if (!haupt) return;
      thumbs.forEach(function (t) {
        t.addEventListener('click', function () {
          thumbs.forEach(function (x) { x.classList.remove('is-aktiv'); x.setAttribute('aria-pressed', 'false'); });
          t.classList.add('is-aktiv');
          t.setAttribute('aria-pressed', 'true');
          haupt.classList.add('is-wechsel');
          var bild = new Image();
          bild.onload = function () {
            haupt.removeAttribute('srcset');
            haupt.src = t.dataset.src;
            haupt.alt = t.dataset.alt || '';
            haupt.classList.remove('is-wechsel');
          };
          bild.src = t.dataset.src;
          if (text) text.textContent = t.dataset.text || '';
        });
      });
    });
  }

  /* ---------- Zielgruppen-Weiche ---------- */
  function weiche() {
    document.querySelectorAll('[data-bvp-weiche]').forEach(function (w) {
      var radios = w.querySelectorAll('[data-bvp-pfad]');
      var inhalte = w.querySelectorAll('[data-bvp-pfad-inhalt]');
      function zeigen() {
        var aktiv = w.querySelector('[data-bvp-pfad]:checked');
        if (!aktiv) return;
        inhalte.forEach(function (i) { i.hidden = i.getAttribute('data-bvp-pfad-inhalt') !== aktiv.getAttribute('data-bvp-pfad'); });
        auswahl.bereich = aktiv.value || null;
      }
      radios.forEach(function (r) { r.addEventListener('change', zeigen); });
      zeigen();
    });
  }

  /* ---------- Aufbau-Bühne ---------- */
  function ablauf() {
    document.querySelectorAll('[data-bvp-ablauf]').forEach(function (sec) {
      var stil = sec.getAttribute('data-bvp-ablauf');
      var buehne = sec.querySelector('[data-bvp-buehne]');
      var nrEl = sec.querySelector('[data-bvp-buehne-nr]');
      var titelEl = sec.querySelector('[data-bvp-buehne-titel]');
      var schritte = sec.querySelectorAll('[data-bvp-schritt]');
      var knoepfe = sec.querySelectorAll('[data-bvp-schritt-knopf]');
      if (!buehne || !schritte.length) return;
      var timer = null;

      function setzen(n) {
        n = Math.max(1, Math.min(4, n));
        buehne.setAttribute('data-s', String(n));
        schritte.forEach(function (s) { s.classList.toggle('is-aktiv', s.getAttribute('data-bvp-schritt') === String(n)); });
        knoepfe.forEach(function (k) { k.setAttribute('aria-pressed', k.getAttribute('data-bvp-schritt-knopf') === String(n) ? 'true' : 'false'); });
        var k = sec.querySelector('[data-bvp-schritt-knopf="' + n + '"]');
        if (nrEl) nrEl.textContent = n;
        if (titelEl && k) titelEl.textContent = k.dataset.titel || '';
      }
      function stopp() { if (timer) { clearInterval(timer); timer = null; } }

      knoepfe.forEach(function (k) {
        k.addEventListener('click', function () { stopp(); setzen(parseInt(k.getAttribute('data-bvp-schritt-knopf'), 10)); });
      });

      if (!('IntersectionObserver' in window)) return;

      if (stil === 'film') {
        setzen(1);
        var io = new IntersectionObserver(function (eintraege) {
          eintraege.forEach(function (e) { if (e.isIntersecting) setzen(parseInt(e.target.getAttribute('data-bvp-schritt'), 10)); });
        }, { rootMargin: '-42% 0px -42% 0px', threshold: 0 });
        schritte.forEach(function (s) { io.observe(s); });
      } else if (bewegung) {
        setzen(1);
        var gespielt = false;
        var io2 = new IntersectionObserver(function (eintraege) {
          eintraege.forEach(function (e) {
            if (!e.isIntersecting || gespielt) return;
            gespielt = true;
            io2.disconnect();
            var n = 1;
            timer = setInterval(function () { n += 1; setzen(n); if (n >= 4) stopp(); }, 1800);
          });
        }, { threshold: 0.45 });
        io2.observe(buehne);
      }
    });
  }

  /* ---------- Anatomie ---------- */
  function anatomie() {
    document.querySelectorAll('[data-bvp-anatomie]').forEach(function (sec) {
      var spots = sec.querySelectorAll('[data-bvp-hotspot]');
      var punkte = sec.querySelectorAll('[data-bvp-hotspot-ziel]');
      function aktiv(n) {
        spots.forEach(function (s) { s.classList.toggle('is-aktiv', s.getAttribute('data-bvp-hotspot') === n); s.setAttribute('aria-pressed', s.getAttribute('data-bvp-hotspot') === n ? 'true' : 'false'); });
        punkte.forEach(function (p) { p.classList.toggle('is-aktiv', p.getAttribute('data-bvp-hotspot-ziel') === n); });
      }
      spots.forEach(function (s) {
        s.addEventListener('click', function () {
          var n = s.getAttribute('data-bvp-hotspot');
          aktiv(n);
          var p = sec.querySelector('[data-bvp-hotspot-ziel="' + n + '"]');
          if (p && window.innerWidth < 990) p.scrollIntoView({ behavior: bewegung ? 'smooth' : 'auto', block: 'nearest' });
        });
      });
      punkte.forEach(function (p) {
        p.addEventListener('mouseenter', function () { aktiv(p.getAttribute('data-bvp-hotspot-ziel')); });
      });
      if (spots.length) aktiv('1');
    });
  }

  /* ---------- Rechner ---------- */
  var TYPEN = [
    { name: 'P2 30', h: 30, h3: 45, d: 30, l: 141.37, w: { 5: 26, 10: 28, 15: 39, 20: 50 } },
    { name: 'M2 50', h: 50, h3: 80, d: 62, l: 603.81, w: { 10: 64, 15: 87, 20: 110 } },
    { name: 'M2 XL 80', h: 80, h3: 130, d: 94, l: 1387.96, w: { 10: 70, 15: 104, 20: 135 } },
    { name: 'H2 100', h: 100, h3: 160, d: 115, l: 2077.38, w: { 10: 109, 15: 144, 20: 179 } },
    { name: 'S2 130', h: 130, h3: 190, d: 140, l: 3078.76, w: { 10: 80, 15: 114, 20: 146 } }
  ];
  var SACK_PUNKTE = [[0, 0], [50, 40], [100, 120], [150, 275]]; /* cm -> Säcke je Meter (LFS BW) */
  var SACK_KG = 18;          /* LFS BW: 18 bis 20 kg je zu 2/3 gefülltem Sack */
  var LEGEN_JE_PH = 80;      /* 800 Säcke/h mit 10 Helfern */
  var FUELLEN_JE_PH = 80;    /* 800 Säcke/h mit 10 Helfern, mit Fülltrichter */
  var BEAVER_M_JE_PH = 20;   /* 100 m mit 5 Helfern in 1 h (Hersteller) */

  function saeckeJeMeter(hcm) {
    for (var i = 1; i < SACK_PUNKTE.length; i++) {
      var a = SACK_PUNKTE[i - 1], b = SACK_PUNKTE[i];
      if (hcm <= b[0]) return a[1] + (hcm - a[0]) * (b[1] - a[1]) / (b[0] - a[0]);
    }
    return SACK_PUNKTE[SACK_PUNKTE.length - 1][1];
  }
  function typFuer(hcm) {
    for (var i = 0; i < TYPEN.length; i++) if (TYPEN[i].h >= hcm) return TYPEN[i];
    return TYPEN[TYPEN.length - 1];
  }
  /* Kleinste abgedeckte Länge, bei Gleichstand die wenigsten Elemente */
  function kombination(typ, L) {
    var laengen = Object.keys(typ.w).map(Number).sort(function (a, b) { return b - a; });
    var bester = null;
    var max20 = Math.ceil(L / 20) + 1;
    var hat5 = laengen.indexOf(5) >= 0;
    for (var a = 0; a <= max20; a++) {
      for (var b = 0; b <= 2; b++) {
        for (var c = 0; c <= 2; c++) {
          for (var d = 0; d <= (hat5 ? 2 : 0); d++) {
            var summe = a * 20 + b * 15 + c * 10 + d * 5;
            if (summe < L) continue;
            var anzahl = a + b + c + d;
            if (!bester || summe < bester.summe || (summe === bester.summe && anzahl < bester.anzahl)) {
              bester = { summe: summe, anzahl: anzahl, n: { 20: a, 15: b, 10: c, 5: d } };
            }
          }
        }
      }
    }
    var teile = [], kg = 0;
    [20, 15, 10, 5].forEach(function (len) {
      var n = bester.n[len];
      if (n > 0) { teile.push(n + ' × ' + len + ' m'); kg += n * typ.w[len]; }
    });
    return { teile: teile, anzahl: bester.anzahl, gedeckt: bester.summe, kg: kg };
  }
  function zeitText(min) {
    if (min < 60) return 'ca. ' + Math.max(5, Math.round(min / 5) * 5) + ' min';
    if (min < 600) {
      var h = Math.floor(min / 60), m = Math.round((min - h * 60) / 10) * 10;
      if (m === 60) { h += 1; m = 0; }
      return 'ca. ' + h + ' h' + (m ? ' ' + m + ' min' : '');
    }
    return 'ca. ' + fmt.format(Math.round(min / 60)) + ' h';
  }
  function kgText(kg) {
    if (kg < 1000) return fmt.format(Math.round(kg)) + ' kg';
    if (kg < 100000) return fmt1.format(kg / 1000) + ' t';
    return fmt.format(Math.round(kg / 1000)) + ' t';
  }
  function tonnenLang(kg) {
    if (kg < 1000) return fmt.format(Math.round(kg)) + ' kg';
    return (kg < 100000 ? fmt1.format(kg / 1000) : fmt.format(Math.round(kg / 1000))) + ' Tonnen';
  }
  function zahlLesen(roh) {
    var s = String(roh || '').trim().replace(/\s/g, '').replace(/m$/i, '');
    if (!s) return NaN;
    if (s.indexOf(',') >= 0) s = s.replace(/\./g, '').replace(',', '.');
    else if (/^\d{1,3}(\.\d{3})+$/.test(s)) s = s.replace(/\./g, '');
    return parseFloat(s);
  }

  var SVGNS = 'http://www.w3.org/2000/svg';
  function svgEl(name, attrs) {
    var el = document.createElementNS(SVGNS, name);
    for (var k in attrs) if (Object.prototype.hasOwnProperty.call(attrs, k)) el.setAttribute(k, attrs[k]);
    return el;
  }
  function wellenPfad(y) {
    var d = 'M-100 ' + y + ' q8 -4 16 0';
    for (var i = 0; i < 34; i++) d += ' t16 0';
    return d;
  }

  function schnittAufbauen(karte) {
    var sand = karte.querySelector('[data-r-svg-sand]');
    var bvp = karte.querySelector('[data-r-svg-beaver]');
    if (!sand || !bvp) return null;
    var BODEN = 205;
    var uid = 'r' + Math.random().toString(36).slice(2, 8);
    /* Sand */
    var sDefs = svgEl('defs', {});
    var sClip = svgEl('clipPath', { id: uid + '-sw' });
    var sClipRect = svgEl('rect', { x: 0, y: 0, width: 100, height: 230 });
    sClip.appendChild(sClipRect); sDefs.appendChild(sClip); sand.appendChild(sDefs);
    var sWasserG = svgEl('g', { 'clip-path': 'url(#' + uid + '-sw)' });
    var sWasser = svgEl('rect', { class: 's-wasser', x: 0, y: BODEN - 150, width: 440, height: 150 });
    var sWelleG = svgEl('g', {});
    var sWelle = svgEl('path', { class: 's-welle', d: wellenPfad(0) });
    sWelleG.appendChild(sWelle);
    sWasserG.appendChild(sWasser); sWasserG.appendChild(sWelleG);
    sand.appendChild(sWasserG);
    var saecke = svgEl('g', {});
    sand.appendChild(saecke);
    sand.appendChild(svgEl('line', { class: 's-boden', x1: 0, y1: BODEN, x2: 440, y2: BODEN }));
    /* Beaver */
    var bDefs = svgEl('defs', {});
    var grad = svgEl('linearGradient', { id: uid + '-k', x1: 0, y1: 0, x2: 0, y2: 1 });
    [['0', '#ff9a52'], ['.55', '#f26a1b'], ['1', '#b9480b']].forEach(function (s) { grad.appendChild(svgEl('stop', { offset: s[0], 'stop-color': s[1] })); });
    var bClip = svgEl('clipPath', { id: uid + '-bw' });
    var bClipRect = svgEl('rect', { x: 0, y: 0, width: 100, height: 230 });
    bClip.appendChild(bClipRect);
    bDefs.appendChild(grad); bDefs.appendChild(bClip); bvp.appendChild(bDefs);
    var bWasserG = svgEl('g', { 'clip-path': 'url(#' + uid + '-bw)' });
    var bWasser = svgEl('rect', { class: 's-wasser', x: 0, y: BODEN - 150, width: 330, height: 150 });
    var bWelleG = svgEl('g', {});
    bWelleG.appendChild(svgEl('path', { class: 's-welle', d: wellenPfad(0) }));
    bWasserG.appendChild(bWasser); bWasserG.appendChild(bWelleG);
    bvp.appendChild(bWasserG);
    var roehren = svgEl('g', { class: 's-roehren' });
    roehren.appendChild(svgEl('ellipse', { class: 's-kammer', cx: 190, cy: BODEN - 44, rx: 50, ry: 44, fill: 'url(#' + uid + '-k)', 'vector-effect': 'non-scaling-stroke' }));
    roehren.appendChild(svgEl('ellipse', { class: 's-kammer', cx: 90, cy: BODEN - 44, rx: 50, ry: 44, fill: 'url(#' + uid + '-k)', 'vector-effect': 'non-scaling-stroke' }));
    bvp.appendChild(roehren);
    bvp.appendChild(svgEl('line', { class: 's-boden', x1: 0, y1: BODEN, x2: 330, y2: BODEN }));
    [sWasser, bWasser, sWelleG, bWelleG, roehren].forEach(function (el) {
      el.style.transition = bewegung ? 'transform .6s cubic-bezier(.16,1,.3,1)' : 'none';
    });
    roehren.style.transformOrigin = '40px ' + BODEN + 'px';
    sWasser.style.transformOrigin = '0 ' + BODEN + 'px';
    bWasser.style.transformOrigin = '0 ' + BODEN + 'px';
    return {
      BODEN: BODEN, saecke: saecke, sClipRect: sClipRect, bClipRect: bClipRect,
      sWasser: sWasser, bWasser: bWasser, sWelleG: sWelleG, bWelleG: bWelleG, roehren: roehren, lagen: -1
    };
  }

  function schnittZeichnen(s, hcm, typ) {
    if (!s) return;
    var lagen = Math.max(2, Math.round(hcm / 10));
    var mitte = 40 + lagen * 15;
    var hFaktor = hcm / 150;
    s.sWasser.style.transform = 'scaleY(' + hFaktor + ')';
    s.bWasser.style.transform = 'scaleY(' + hFaktor + ')';
    s.sWelleG.style.transform = 'translateY(' + (s.BODEN - hcm) + 'px)';
    s.bWelleG.style.transform = 'translateY(' + (s.BODEN - hcm) + 'px)';
    s.sClipRect.setAttribute('width', mitte);
    s.bClipRect.setAttribute('width', 40 + typ.d / 2);
    s.roehren.style.transform = 'scale(' + (typ.d / 100) + ')';
    if (lagen !== s.lagen) {
      var neu = s.lagen >= 0;
      var frag = document.createDocumentFragment();
      var i = 0;
      for (var k = 0; k < lagen; k++) {
        for (var j = 0; j < lagen - k; j++) {
          var r = svgEl('rect', { class: 's-sack' + (neu ? ' is-neu' : ''), x: 40 + k * 15 + j * 30 + 0.5, y: s.BODEN - (k + 1) * 10, width: 29, height: 10.5, rx: 4 });
          if (neu) r.style.setProperty('--i', String(Math.min(i, 60)));
          frag.appendChild(r);
          i++;
        }
      }
      while (s.saecke.firstChild) s.saecke.removeChild(s.saecke.firstChild);
      s.saecke.appendChild(frag);
      s.lagen = lagen;
    }
    return { lagen: lagen, breite: lagen * 0.3 };
  }

  function rechner() {
    document.querySelectorAll('[data-bvp-rechner]').forEach(function (karte) {
      var q = function (sel) { return karte.querySelector(sel); };
      var hoeheEl = q('[data-r-hoehe]'), hoeheOut = q('[data-r-hoehe-out]');
      var laengeEl = q('[data-r-laenge]'), teamEl = q('[data-r-team]'), pumpeEl = q('[data-r-pumpe]');
      var fehler = q('[data-r-fehler]');
      var ergebnis = q('.bvp-rechner__ergebnis');
      var cta = q('[data-r-cta]');
      var zeilen = {};
      karte.querySelectorAll('[data-r-zeile]').forEach(function (z) { zeilen[z.getAttribute('data-r-zeile')] = z; });
      var schnitt = schnittAufbauen(karte);
      var benutzt = false;
      var neuTimer = null;

      function zeileSetzen(name, sandText, bvpText, sandWert, bvpWert) {
        var z = zeilen[name];
        if (!z) return;
        var max = Math.max(sandWert, bvpWert) || 1;
        var s = z.querySelector('.bvp-duell__sand'), b = z.querySelector('.bvp-duell__beaver');
        s.querySelector('[data-r-v]').textContent = sandText;
        b.querySelector('[data-r-v]').textContent = bvpText;
        s.querySelector('.bvp-duell__balken').style.setProperty('--w', Math.max(2, sandWert / max * 100) + '%');
        b.querySelector('.bvp-duell__balken').style.setProperty('--w', Math.max(2, bvpWert / max * 100) + '%');
      }
      function chipsSync(attr, wert) {
        karte.querySelectorAll('[' + attr + ']').forEach(function (c) {
          var an = parseFloat(c.getAttribute(attr)) === wert;
          c.classList.toggle('is-aktiv', an);
          c.setAttribute('aria-pressed', an ? 'true' : 'false');
        });
      }

      function rechnen(vomNutzer) {
        var h = parseInt(hoeheEl.value, 10) || 50;
        var L = zahlLesen(laengeEl.value);
        var P = Math.round(zahlLesen(teamEl.value));
        var Q = parseInt(pumpeEl && pumpeEl.value, 10) || parseInt(karte.dataset.pumpe, 10) || 2000;
        var sackModus = (karte.querySelector('[data-r-sack]:checked') || {}).value || 'gefuellt';

        hoeheOut.textContent = h + ' cm';
        hoeheEl.style.setProperty('--p', ((h - 20) / 110 * 100) + '%');
        var typ = typFuer(h);
        karte.querySelectorAll('.bvp-typskala li').forEach(function (li) { li.classList.toggle('is-aktiv', li.getAttribute('data-typ') === typ.name); });

        var gueltig = isFinite(L) && L >= 5;
        if (fehler) fehler.hidden = gueltig;
        if (!gueltig) return;
        L = Math.min(L, 5000);
        if (!isFinite(P) || P < 1) P = 1;
        P = Math.min(P, 500);
        chipsSync('data-r-laenge-chip', L);
        chipsSync('data-r-team-chip', P);

        /* Sandsack */
        var saecke = Math.ceil(saeckeJeMeter(h) * L);
        var sandKg = saecke * SACK_KG;
        var sandPh = saecke / LEGEN_JE_PH + (sackModus === 'vorort' ? saecke / FUELLEN_JE_PH : 0);
        var sandMin = sandPh / P * 60;
        var heben = sackModus === 'vorort' ? 2 : 1;
        var lastSand = sandKg * heben / P;

        /* Beaver */
        var k = kombination(typ, L);
        var wasserL = k.gedeckt * typ.l;
        var fuellMin = wasserL / Q;
        var legMin = L / BEAVER_M_JE_PH / P * 60;
        var bvpMin = Math.max(5, legMin, fuellMin);
        var lastBvp = k.kg / P;
        var tempo = Math.ceil(sandPh / (bvpMin / 60));
        var faktor = sandMin / bvpMin;

        q('[data-r-typ]').textContent = typ.name;
        q('[data-r-elemente]').textContent = k.teile.join(' + ') + (k.gedeckt > L ? ', zusammen ' + fmt.format(k.gedeckt) + ' m' : '');
        q('[data-r-leer]').textContent = 'ca. ' + kgText(k.kg);
        q('[data-r-wasser]').textContent = 'ca. ' + fmt.format(Math.max(1, Math.round(wasserL / 1000))) + ' m³';
        q('[data-r-fuell]').textContent = zeitText(fuellMin);
        q('[data-r-aufsatz]').textContent = 'bis ' + typ.h3 + ' cm';
        var teamText = q('[data-r-team-text]');
        if (teamText) teamText.textContent = 'mit ' + fmt.format(P) + (P === 1 ? ' Einsatzkraft' : ' Einsatzkräften');

        zeileSetzen('zeit', zeitText(sandMin), zeitText(bvpMin), sandMin, bvpMin);
        zeileSetzen('last', kgText(lastSand), kgText(lastBvp), lastSand, lastBvp);
        zeileSetzen('material', fmt.format(saecke) + ' Säcke, ' + kgText(sandKg) + ' Sand', k.anzahl + (k.anzahl === 1 ? ' Element, ' : ' Elemente, ') + kgText(k.kg), sandKg, k.kg);
        zeileSetzen('tempo', fmt.format(tempo), fmt.format(P), tempo, P);

        var fazit = q('[data-r-fazit]');
        var lastSatz = ' Jede Einsatzkraft hebt ' + kgText(lastBvp) + ' statt ' + tonnenLang(lastSand) + '.';
        if (faktor >= 1.5) {
          fazit.innerHTML = 'Mit dem Beaver steht Deine Schutzlinie <mark class="bvp-mark bvp-mark--gruen">rund ' + fmt.format(Math.round(faktor)) + '-mal schneller</mark>.' + lastSatz;
        } else {
          fazit.innerHTML = 'Bei dieser kurzen Schutzlinie ist das Tempo ähnlich, die Last nicht.' + lastSatz;
        }

        var lagenInfo = schnittZeichnen(schnitt, h, typ);
        var sl = q('[data-r-sand-label]'), bl = q('[data-r-beaver-label]');
        if (sl && lagenInfo) sl.textContent = 'Sandsackdamm · ' + lagenInfo.lagen + ' Lagen, ' + fmt1.format(lagenInfo.breite) + ' m breit';
        if (bl) bl.textContent = 'Beaver ' + typ.name + ' · ' + fmt1.format(typ.d * 2 / 100) + ' m breit';

        var nachricht = 'Aus dem Schutzlinien-Rechner: ' + fmt.format(L) + ' m Schutzlinie, ' + h + ' cm Stauhöhe. Vorschlag Beaver ' + typ.name + ' (' + k.teile.join(' + ') + '). Vor Ort ' + P + ' Einsatzkräfte, Befüllung ' + fmt.format(Q) + ' l/min.';
        if (cta) {
          cta.dataset.typ = typ.name;
          cta.dataset.laenge = fmt.format(L) + ' m';
          cta.dataset.hoehe = h + ' cm';
          cta.dataset.nachricht = nachricht;
        }
        if (vomNutzer) {
          benutzt = true;
          auswahl.rechner = { typ: typ.name, laenge: fmt.format(L) + ' m', hoehe: h + ' cm', nachricht: nachricht };
          var info = document.querySelector('[data-bvp-sticky-info]');
          if (info) info.textContent = 'Vorschlag: ' + typ.name + ', ' + k.teile.join(' + ');
          if (bewegung && ergebnis) {
            ergebnis.classList.remove('is-neu');
            void ergebnis.offsetWidth;
            ergebnis.classList.add('is-neu');
            clearTimeout(neuTimer);
            neuTimer = setTimeout(function () { ergebnis.classList.remove('is-neu'); }, 500);
          }
        }
      }

      hoeheEl.addEventListener('input', function () { rechnen(true); });
      laengeEl.addEventListener('input', function () { rechnen(true); });
      laengeEl.addEventListener('blur', function () { var v = zahlLesen(laengeEl.value); if (isFinite(v) && v >= 5) laengeEl.value = fmt.format(Math.min(v, 5000)); });
      teamEl.addEventListener('input', function () { rechnen(true); });
      if (pumpeEl) pumpeEl.addEventListener('change', function () { rechnen(true); });
      karte.querySelectorAll('[data-r-sack]').forEach(function (r) { r.addEventListener('change', function () { rechnen(true); }); });
      karte.querySelectorAll('[data-r-schritt]').forEach(function (b) {
        b.addEventListener('click', function () {
          var v = zahlLesen(laengeEl.value); if (!isFinite(v)) v = 0;
          v = Math.max(5, Math.min(5000, Math.round((v + parseFloat(b.getAttribute('data-r-schritt'))) / 5) * 5));
          laengeEl.value = fmt.format(v);
          rechnen(true);
        });
      });
      karte.querySelectorAll('[data-r-laenge-chip]').forEach(function (c) {
        c.addEventListener('click', function () { laengeEl.value = fmt.format(parseFloat(c.getAttribute('data-r-laenge-chip'))); rechnen(true); });
      });
      karte.querySelectorAll('[data-r-team-chip]').forEach(function (c) {
        c.addEventListener('click', function () { teamEl.value = c.getAttribute('data-r-team-chip'); rechnen(true); });
      });
      rechnen(false);
    });
  }

  /* ---------- Formular vorbelegen ---------- */
  function feldSetzen(el, wert) {
    if (!el || wert == null || wert === '') return false;
    if (el.tagName === 'SELECT') {
      var treffer = Array.prototype.some.call(el.options, function (o) { return o.value === wert; });
      if (!treffer) return false;
    }
    if (el.value === wert) return false;
    el.value = wert;
    var feld = el.closest('.bvp-feld');
    if (feld) {
      feld.classList.add('is-vorbelegt');
      el.addEventListener('input', function weg() { feld.classList.remove('is-vorbelegt'); el.removeEventListener('input', weg); });
    }
    return true;
  }
  function vorbelegen(knopf) {
    var form = document.getElementById('ContactForm');
    if (!form) return;
    var d = knopf.dataset;
    var r = auswahl.rechner || {};
    feldSetzen(form.querySelector('[data-bvp-f-typ]'), d.typ || r.typ);
    feldSetzen(form.querySelector('[data-bvp-f-laenge]'), d.laenge || r.laenge);
    feldSetzen(form.querySelector('[data-bvp-f-hoehe]'), d.hoehe || r.hoehe);
    feldSetzen(form.querySelector('[data-bvp-f-bereich]'), d.bereich || auswahl.bereich);
    var quelle = form.querySelector('[data-bvp-f-quelle]');
    if (quelle && d.bvpQuelle) quelle.value = 'Button: ' + d.bvpQuelle;
    var text = form.querySelector('[data-bvp-f-nachricht]');
    var nachricht = d.nachricht || r.nachricht;
    if (text && nachricht && (!text.value || text.dataset.auto === '1')) {
      text.value = nachricht;
      text.dataset.auto = '1';
      text.addEventListener('input', function () { text.dataset.auto = '0'; }, { once: true });
    }
  }
  function quellenLinks() {
    document.querySelectorAll('.bvp-rechner__basis a[href^="#bvp-quellen-"]').forEach(function (a) {
      a.addEventListener('click', function () { var d = document.querySelector(a.getAttribute('href')); if (d) d.open = true; });
    });
  }
  function anfrageKnoepfe() {
    document.addEventListener('click', function (e) {
      var k = e.target.closest && e.target.closest('[data-bvp-anfrage]');
      if (k) vorbelegen(k);
    });
  }

  /* ---------- Anfrageleiste ---------- */
  function leiste() {
    var el = document.querySelector('[data-bvp-sticky]');
    if (!el || !('IntersectionObserver' in window)) return;
    var kopf = document.querySelector('[data-bvp-kopf] .bvp-kauf__aktionen') || document.querySelector('[data-bvp-kopf]');
    var form = document.querySelector('[data-bvp-anfrage-section]');
    var kopfSichtbar = true, formSichtbar = false;
    el.hidden = false;
    function update() {
      var an = !kopfSichtbar && !formSichtbar;
      el.classList.toggle('is-an', an);
      el.setAttribute('aria-hidden', an ? 'false' : 'true');
      el.querySelectorAll('a').forEach(function (a) { a.tabIndex = an ? 0 : -1; });
      document.body.classList.toggle('bvp-sticky-offen', an);
    }
    var io = new IntersectionObserver(function (eintraege) {
      eintraege.forEach(function (e) {
        if (e.target === kopf) kopfSichtbar = e.isIntersecting;
        if (e.target === form) formSichtbar = e.isIntersecting;
      });
      update();
    }, { threshold: 0 });
    if (kopf) io.observe(kopf); else kopfSichtbar = false;
    if (form) io.observe(form);
    update();
  }

  bereit(function () {
    einblenden();
    zaehler();
    galerie();
    weiche();
    ablauf();
    anatomie();
    rechner();
    anfrageKnoepfe();
    quellenLinks();
    leiste();
  });
})();
